'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var domCache = require('dom-cache');

var dom = {};
var isTouch;
var isIos;

dom.html = $('html');
dom.app = $('.app');

dom.topBar = dom.app.find('.top-bar');
dom.eventCrumb = dom.topBar.find('.breadcrumb__crumb--event');
// dom.galleryCrumb = dom.topBar.find('.breadcrumb__crumb--gallery');

dom.appHeader = dom.app.find('.app__header');

dom.gallerySelect = dom.appHeader.find('.gallery-select');
dom.gallerySelectFavorites = dom.gallerySelect.find('.gallery-select__favorites');

dom.galleryList = dom.appHeader.find('.gallery-list');
dom.galleryListFavoriteCount = dom.appHeader.find('.gallery-list__favorite-cnt');

dom.appContent = dom.app.find('.app__content');

dom.grid = dom.appContent.find('.image-grid');

dom.appFooter = dom.app.find('.app__footer');

dom.slideshow = dom.app.find('.slideshow');
dom.slideshowImageMeta = dom.slideshow.find('.slideshow__image-meta');
dom.slideshowImageMetaCaption = dom.slideshowImageMeta.find('.slideshow__image-meta-caption');
dom.slideshowImageMetaName = dom.slideshowImageMeta.find('.slideshow__image-meta-name');
dom.slideshowImageMetaFavoriteBtn = dom.slideshowImageMeta.find('.slideshow__image-meta-btn--favorite');
dom.slideshowSlider = dom.slideshow.find('.slideshow__slider');
dom.slideshowPrevHoverZone = dom.slideshow.find('.slideshow__control-hover-zone--prev');
dom.slideshowNextHoverZone = dom.slideshow.find('.slideshow__control-hover-zone--next');
dom.slideshowCompare = dom.slideshow.find('.slideshow__compare');

dom.loader = dom.app.find('.loader');

dom.mainNav = dom.app.find('.main-nav');
dom.mainNavCommentCount = dom.mainNav.find('.main-nav__comment-cnt');
dom.mainNavFavoriteCount = dom.mainNav.find('.main-nav__favorite-cnt');
dom.mainNavLogout = dom.mainNav.find('.main-nav__menu-link--logout');
dom.mainNavContactEmail = dom.mainNav.find('.main-nav__contact-email');

dom.sidePanel = dom.app.find('.side-panel');

dom.cart = dom.app.find('.cart');

dom.isTouch = function() {

	if (typeof isTouch === 'undefined') {

		isTouch = dom.app.hasClass('app--touch');

	}

	return isTouch;

};

dom.isIos = function() {

	if (typeof isIos === 'undefined') {

		isIos = dom.app.hasClass('app--touch') && dom.app.hasClass('app--mac');

	}

	return isIos;

};

// Extend the generic dom-cache with app specific elements.
module.exports = $.extend(domCache, dom);
